import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import useIsMobile from '../../Hooks/useIsMobile';
import Icon from '../IconBase/Icon';
import(`./styles/${window.__litium.themeName}.scss`);

const TEMP_CLASS = 'temp-aspect-ratio-class';

const SlickSlider = ({ values }) => {
  const sliderRef = useRef();
  const currentSliderRef = useRef();
  const [currentSlide, setCurrentSlide] = useState(0);

  const next = () => {
    sliderRef.current.slickNext();
  };
  const prev = () => {
    sliderRef.current.slickPrev();
  };

  useEffect(() => {
    const sliderWrapper = currentSliderRef.current.closest('.' + TEMP_CLASS);

    setTimeout(() => {
      sliderWrapper.classList.remove(TEMP_CLASS);
    }, '1000');
  }, []);

  const CustomArrows = () => {
    return (
      <div className="slick-slider__pagination" ref={currentSliderRef}>
        {values.length > 1 && (
          <>
            <div
              className="slick-slider__button slick-slider__button--prev"
              onClick={prev}
            >
              <Icon
                iconCode="chevron_left"
                iconClass={`${
                  window.__litium.themeName == 'vincent'
                    ? 'material-symbols--small-thin'
                    : ''
                }`}
              />
            </div>
            <div className="slick-slider__custom-indicator">
              {currentSlide + 1}/{values.length}
            </div>
            <div
              className="slick-slider__button slick-slider__button--next"
              onClick={next}
            >
              <Icon
                iconCode="chevron_right"
                iconClass={`${
                  window.__litium.themeName == 'vincent'
                    ? 'material-symbols--small-thin'
                    : ''
                }`}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  var isMobile = useIsMobile();
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="slick-slider__content-wrapper">
      <Slider ref={sliderRef} {...settings}>
        {values.map((value, index) => (
          <div
            key={`figure${index}`}
            dangerouslySetInnerHTML={{
              __html: value.html,
            }}
          ></div>
        ))}
      </Slider>
      <CustomArrows />
    </div>
  );
};

export default SlickSlider;
